import { render } from "./pca-form-date-box.vue?vue&type=template&id=538c0b7c"
import script from "./pca-form-date-box.vue?vue&type=script&setup=true&lang=js"
export * from "./pca-form-date-box.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/print-contract/components/pca-form-date-box.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "538c0b7c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('538c0b7c', __exports__)) {
    api.reload('538c0b7c', __exports__)
  }
  
  module.hot.accept("./pca-form-date-box.vue?vue&type=template&id=538c0b7c", () => {
    api.rerender('538c0b7c', render)
  })

}


export default __exports__